import { z } from "zod";
export var LocalContentType;
(function (LocalContentType) {
    LocalContentType["Building"] = "local-content-type_building";
    LocalContentType["FFE"] = "local-content-type_ffe";
    LocalContentType["SteelRelatedItems"] = "local-content-type_steel-related-items";
    LocalContentType["Other"] = "local-content-type_other";
    LocalContentType["SpecialistEquipment"] = "local-content-type_specialist-equipment";
    LocalContentType["Infrastructure"] = "local-content-type_infrastructure";
    LocalContentType["SupplyOfProductAndMaterials"] = "local-content-type_supply-of-product-and-materials";
    LocalContentType["PlantAndEquipment"] = "local-content-type_plant-and-equipment";
    LocalContentType["Labour"] = "local-content-type_labour";
    LocalContentType["BatteryEnergyStorageSystem"] = "local-content-type_battery-energy-storage-system";
    LocalContentType["OperationsMaintenance"] = "local-content-type_operations-maintenance";
    LocalContentType["LicencesWarrantiesSpares"] = "local-content-type_licences-warranties-spares";
    LocalContentType["SolarFarm"] = "local-content-type_solar-farm";
    LocalContentType["SolarFarmElectricalItems"] = "local-content-type_solar-farm-electrical-items";
    LocalContentType["SolarFarmSteelItems"] = "local-content-type_solar-farm-steel-items";
    LocalContentType["SolarFarmOperations"] = "local-content-type_solar-farm-operations";
    LocalContentType["WindTurbine"] = "local-content-type_wind-turbine";
    LocalContentType["ElectricalSubstation"] = "local-content-type_electrical-substation";
    LocalContentType["InfrastructureSpareParts"] = "local-content-type_infrastructure-spare-parts";
    LocalContentType["OperationsAndMaintenance"] = "local-content-type_operations-and-maintenance";
    LocalContentType["VehicleSpareParts"] = "local-content-type_vehicle-spare-parts";
})(LocalContentType || (LocalContentType = {}));
export const localContentTypeToStringAbbreviated = (type) => {
    switch (type) {
        case LocalContentType.Building:
            return "Building";
        case LocalContentType.FFE:
            return "FFE";
        case LocalContentType.SteelRelatedItems:
            return "Steel";
        case LocalContentType.Other:
            return "Other";
        case LocalContentType.SpecialistEquipment:
            return "Specialist Equipment";
        case LocalContentType.Infrastructure:
            return "Infrastructure";
        case LocalContentType.SupplyOfProductAndMaterials:
            return "Product & Materials";
        case LocalContentType.PlantAndEquipment:
            return "Plant & Equipment";
        case LocalContentType.Labour:
            return "Labour";
        case LocalContentType.BatteryEnergyStorageSystem:
            return "Battery Energy Storage System";
        case LocalContentType.OperationsMaintenance:
            return "Operations & Maintenance";
        case LocalContentType.LicencesWarrantiesSpares:
            return "Licences / Warranties / Spares";
        case LocalContentType.SolarFarm:
            return "Solar Farm";
        case LocalContentType.SolarFarmElectricalItems:
            return "Solar Farm - Electrical Items";
        case LocalContentType.SolarFarmSteelItems:
            return "Solar Farm - Steel Items";
        case LocalContentType.SolarFarmOperations:
            return "Solar Farm - Operations";
        case LocalContentType.WindTurbine:
            return "Wind Turbine";
        case LocalContentType.ElectricalSubstation:
            return "Electrical Substation";
        case LocalContentType.InfrastructureSpareParts:
            return "Infrastructure Spare Parts";
        case LocalContentType.OperationsAndMaintenance:
            return "Operations and Maintenance";
        case LocalContentType.VehicleSpareParts:
            return "Vehicle Spare Parts";
        default:
            throw new Error(`Unknown content type: ${type}`);
    }
};
export const localContentTypeToString = (type) => {
    switch (type) {
        case LocalContentType.Building:
            return "Building";
        case LocalContentType.FFE:
            return "Fixtures, Fittings & Equipment";
        case LocalContentType.SteelRelatedItems:
            return "Steel Related Items";
        case LocalContentType.Other:
            return "Other";
        case LocalContentType.SpecialistEquipment:
            return "Specialist Equipment";
        case LocalContentType.Infrastructure:
            return "Infrastructure";
        case LocalContentType.SupplyOfProductAndMaterials:
            return "Supply of Product & Materials";
        case LocalContentType.PlantAndEquipment:
            return "Plant & Equipment";
        case LocalContentType.Labour:
            return "Labour";
        case LocalContentType.BatteryEnergyStorageSystem:
            return "Battery Energy Storage System";
        case LocalContentType.OperationsMaintenance:
            return "Operations & Maintenance";
        case LocalContentType.LicencesWarrantiesSpares:
            return "Licences / Warranties / Spares";
        case LocalContentType.SolarFarm:
            return "Solar Farm";
        case LocalContentType.SolarFarmElectricalItems:
            return "Solar Farm - Electrical Items";
        case LocalContentType.SolarFarmSteelItems:
            return "Solar Farm - Steel Items";
        case LocalContentType.SolarFarmOperations:
            return "Solar Farm - Operations";
        case LocalContentType.WindTurbine:
            return "Wind Turbine";
        case LocalContentType.ElectricalSubstation:
            return "Electrical Substation";
        case LocalContentType.InfrastructureSpareParts:
            return "Infrastructure Spare Parts";
        case LocalContentType.OperationsAndMaintenance:
            return "Operations and Maintenance";
        case LocalContentType.VehicleSpareParts:
            return "Vehicle Spare Parts";
        default:
            throw new Error(`Unknown content type: ${type}`);
    }
};
export const stringImportToLocalContentType = (localContentType) => {
    if (!localContentType) {
        return undefined;
    }
    switch (localContentType.toLowerCase().trim()) {
        default:
            return undefined;
        case "building":
            return LocalContentType.Building;
        case "fixtures, fittings & equipment":
            return LocalContentType.FFE;
        case "steel related items":
            return LocalContentType.SteelRelatedItems;
        case "other":
            return LocalContentType.Other;
        case "specialist equipment":
            return LocalContentType.SpecialistEquipment;
        case "infrastructure":
            return LocalContentType.Infrastructure;
        case "supply of product & materials":
            return LocalContentType.SupplyOfProductAndMaterials;
        case "plant & equipment":
            return LocalContentType.PlantAndEquipment;
        case "labour":
            return LocalContentType.Labour;
        case "battery energy storage system":
            return LocalContentType.BatteryEnergyStorageSystem;
        case "operations & maintenance":
            return LocalContentType.OperationsMaintenance;
        case "licences / warranties / spares":
            return LocalContentType.LicencesWarrantiesSpares;
        case "solar farm":
            return LocalContentType.SolarFarm;
        case "solar farm - electrical items":
            return LocalContentType.SolarFarmElectricalItems;
        case "solar farm - steel items":
            return LocalContentType.SolarFarmSteelItems;
        case "solar farm - operations":
            return LocalContentType.SolarFarmOperations;
        case "wind turbine":
            return LocalContentType.WindTurbine;
        case "electrical substation":
            return LocalContentType.ElectricalSubstation;
        case "infrastructure spare parts":
            return LocalContentType.InfrastructureSpareParts;
        case "operations and maintenance":
            return LocalContentType.OperationsAndMaintenance;
        case "vehicle spare parts":
            return LocalContentType.VehicleSpareParts;
    }
};
export const contentSourceSchema = z.object({
    abn: z.string(),
    name: z.string(),
    post_code: z.string()
});
export const packageLocalContentSchema = z.object({
    contract_content: z.number(),
    contractor_package_id: z.string(),
    created: z.date(),
    /** Percentage of (National × Regional) */
    district_value_add: z.number(),
    /** Represents National level (base tier) */
    local_value_add: z.number(),
    manufacturer_abns: z.array(contentSourceSchema),
    package_local_content_id: z.string(),
    project_id: z.string(),
    project_local_content_id: z.string(),
    /** Percentage of National */
    regional_value_add: z.number(),
    report_id: z.string(),
    sme_count: z.number(),
    steel_mass: z.number(),
    supplier_abns: z.array(contentSourceSchema),
    supplier_count: z.number(),
    value: z.number()
});
export const recentlyUsedLocalContentABNSchema = z.object({
    abn: z.string(),
    company_name: z.string(),
    created: z.date(),
    frequency: z.number(),
    id: z.string(),
    post_code: z.string(),
    project_id: z.string()
});
/**
 * Creates a duplicate of a PackageLocalContent record for a new report period.
 * Rolls over: project_local_content_id (item description), manufacturer_abns, supplier_abns.
 * Resets to zero: value, local_value_add, regional_value_add, district_value_add,
 * contract_content, sme_count, steel_mass, supplier_count.
 */
export const duplicatePackageLocalContentForNewReport = (record, newReportId, newId) => ({
    // copy only Item description
    ...record,
    contract_content: 0,
    district_value_add: 0,
    local_value_add: 0,
    manufacturer_abns: [],
    package_local_content_id: newId,
    regional_value_add: 0,
    report_id: newReportId,
    sme_count: 0,
    steel_mass: 0,
    supplier_abns: [],
    supplier_count: 0,
    value: 0
});
export const rollOverPackageLocalContentData = (record, newReportId, newId) => ({
    // copy only Item description, manufacturer_abns, supplier_abns
    ...record,
    contract_content: 0,
    district_value_add: 0,
    local_value_add: 0,
    package_local_content_id: newId,
    regional_value_add: 0,
    report_id: newReportId,
    sme_count: 0,
    steel_mass: 0,
    supplier_count: 0,
    value: 0
});
